import lazyLoading from './lazyLoading'

export default {
  name: 'mypayments',
  path: '/mypayments',
  // component: lazyLoading('monitor/leaflet-maps/LeafletMapsPage'),
  component: lazyLoading('app/mypayments/MyPayments'),
  meta: {
    default: false,
    title: 'Mis pagos',
    iconClass: 'fa fa-money',
    requiresAuth: true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/owner.js